export const getCareerIcon = (cluster: string) => {
  switch (cluster) {
    case "Advanced Manufacturing":
      return "advanced_manufacturing.png"
    case "Construction":
      return "construction.png"
    case "Energy & Natural Resources":
      return "energy.png"
    case "Healthcare & Human Services":
      return "healthcare.png"
    case "Public Service & Safety":
      return "public-service.png"
    case "Management & Entrepreneurship":
      return "management.png"
    case "Digital Technology":
      return "digital-technology.png"
    case "Arts, Entertainment, & Design":
      return "arts-design.png"
    case "Hospitality, Events, & Tourism":
      return "hospitality.png"
    case "Marketing & Sales":
      return "marketing.png"
    case "Agriculture":
      return "agriculture.png"
    case "Supply Chain & Transportation":
      return "supply-chain.png"
    case "Education":
      return "education.png"
    case "Financial Services":
      return "financial.png"
    default:
      return "generic.svg";
  }
}

export const getCareerEducation = (jobZone: number) => {
  switch (jobZone) {
    case 1:
      return "high_school";
    case 2:
      return "high_school";
    case 3:
      return "associate_degree";
    case 4:
      return "bachelor_degree";
    case 5:
        return "graduate";
    default:
      return "";
  }
}

// Add this helper to format with thousands separators, preserving a leading '$' if present.
export const formatSalary = (value: string | number | null | undefined): string => {
  if (value === null || value === undefined) return 'N/A';

  const raw = String(value).trim();
  if (!raw || raw.toLowerCase() === 'nan') return 'N/A';

  // strip everything except digits and a decimal point
  const cleaned = raw.replace(/[^0-9.]/g, '');
  if (!cleaned || cleaned === '.') return 'N/A';

  const num = Number(cleaned);
  if (Number.isNaN(num)) return 'N/A';

  const [intPart, decPart] = cleaned.split('.');
  const withCommas = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  const formatted = decPart ? `${withCommas}.${decPart}` : withCommas;
  return `$${formatted}`;
}